import { theme } from './default';

export const hkduTheme = {
  ...theme,
  name: 'hkdu',
};
